export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const params = new URLSearchParams(window.location.search);

    const h = params.get('h');
    const a = params.get('a');
    const wd = params.get('wd');

    if (!isNaN(h) & !isNaN(a) & !isNaN(wd)) {
      $('#overtime').val(h);
      $('#salary').val(a);
      $('#number-of-weeks').html(wd);
    }

    calculateValues();

    $('input[type=range]').on('input', calculateValues);

    updateTooltip('#salary', '#salary-tooltip', true);
    updateTooltip('#overtime', '#overtime-tooltip', false);

    let wpcf7Element = document.querySelector('.lead-calculator .wpcf7');

    if (wpcf7Element) {
      wpcf7Element.addEventListener( 'wpcf7submit', function() {
        const unpaidHoursValue = $('#unpaid-hours-new').html();
        const financialVal = $('#financial-value-new').html();

        setTimeout(function() {
          $('#unpaidHoursField').val(unpaidHoursValue);
          $('#unclaimedSalaryField').val('£ ' + financialVal.toLocaleString());
        }, 10);
      }, false );
    }
  },
};

$(window).on('resize', function () {
  updateTooltip('#salary', '#salary-tooltip', true);
  updateTooltip('#overtime', '#overtime-tooltip', false);
});

$(window).on('load', function () {
  updateTooltip('#salary', '#salary-tooltip', true);
  updateTooltip('#overtime', '#overtime-tooltip', false);
});

function updateTooltip(slider, tooltip, isSalary = false) {
  let value = parseInt($(slider).val());
  let formattedValue = isSalary ? `£${value / 1000}K` : `${value}h`;

  $(tooltip).text(formattedValue);

  let percent =
    ((value - $(slider).attr('min')) /
      ($(slider).attr('max') - $(slider).attr('min'))) *
    100;

  let sliderWidth = $(slider).width();
  let thumbWidth = 18; // Approximate thumb width
  let offset = (percent / 100) * (sliderWidth - thumbWidth) + thumbWidth / 2;

  $(tooltip).css({
    'left': `${offset}px`,
    'visibility': 'visible',
  });

  // Fill range with color
  $(slider).css(
    'background',
    `linear-gradient(to right, #0d8cff ${percent}%, #e2e2e2 ${percent}%)`
  );
}

function calculateValues() {
  let weeklyOvertime = parseInt($('#overtime').val());
  let annualSalary = parseInt($('#salary').val());

  let workingWeeks = parseInt($('#number-of-weeks').html());
  if (isNaN(workingWeeks)) {
    workingWeeks = 40;
  }

  let unpaidHours = weeklyOvertime * workingWeeks;
  let unpaidDays =  Math.round(unpaidHours / 6);
  let hourlyRate = annualSalary / (30 * workingWeeks);
  let financialValue = Math.round(unpaidHours * hourlyRate);

  animateValue('#unpaid-hours-new', parseInt($('#unpaid-hours-new').text()), unpaidDays);
  animateValue('#financial-value-new', parseInt($('#financial-value-new').text()), financialValue);

  updateTooltip('#salary', '#salary-tooltip', true);
  updateTooltip('#overtime', '#overtime-tooltip', false);

  $('#unpaidHoursField').val(unpaidDays.toLocaleString());
  $('#unclaimedSalaryField').val('£ ' + financialValue.toLocaleString());
}

function animateValue(id, start, end) {
  let obj = $(id);
  let isFinancial = id === '#financial-value-new';

  $({ val: start }).animate({ val: end }, {
    duration: 500,
    step: function (val) {
      let displayVal = isFinancial ? Math.round(val).toLocaleString() : Math.round(val);
      obj.text(displayVal);
    },
  });
}
